import React from "react";
import AppFooterWeb from "../../components/AppFooterWeb";

export class Arpage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <div className="banner-section">
          <div className="ar-page">
            <div className="ar-page-container">
              <img
                src={require("../../assets/images/AR icon.png")}
                className="ARpage-img"
                alt="ARicon"
              />
              <h5>Electrified AR</h5>
              <h6>
                Designed by students of <br></br>
                Drexel's Digital Media program.
              </h6>
            </div>
            <div className="ar-page-details">
              <div className="ar-page-container">
                <h4>Journey to the Dark Side of the Moon</h4>
                <p>
                  Select a song, a color scheme, and a planet to customize your
                  own Pink Floyd inspired celestial light show, designed by
                  students of Drexel's Digital Media program. Tap to place the
                  portal on the ground, walk through it, and enjoy a unique
                  listening experience!
                </p>
                <button type="button" className="start-btn" id="web-startbtn">
                  Start Journey
                </button>
                <button
                  type="button"
                  className="start-btn"
                  id="mobile-namechange"
                >
                  Customize Journey
                </button>
              </div>
            </div>
            <div className="ar-page-container">
              <h4>Design a Fender Stratocaster</h4>
              <p>
                Experiment with different colors and patterns to design your own
                Fender Stratocaster inspired by the painted guitars in this
                exhibition. Take a photo and share it with friends! This AR
                filter was designed by students of Drexel's Digital Media
                program.
              </p>
              <button type="button" className="btn-design">
                Design Guitar
              </button>
            </div>
            <div className="ar-page-details">
              <div className="ar-page-container">
                <h4>Road to the Bossone Building</h4>
                <p>
                  Looking for directions to the second part of the exhibit? From
                  the painted Cadillac in front of the Peck building, walk to
                  the street, turn right, and open this filter. Tap the ground
                  to reveal a groovy path designed by students of Drexel's
                  Digital Media program.
                </p>
                <button type="button" className="start-btn" id="launch-btn">
                  Launch when in front of the Peck Building
                </button>
              </div>
            </div>
            <div className="ar-page-container">
              <h4>3D Electrified Map</h4>
              <p>
                Looking for an exhibit? Open this AR filter and tap the ground
                for a 3D map of Electrified. (Hint: The Live Aid session is on
                the second floor of the Bossone building! This filter can help
                you find accessible entrances.)
              </p>
              <button type="button" className="btn-design">
                Map It
              </button>
            </div>
          </div>
        </div>
        <AppFooterWeb
          pathName={this.props.location?.pathname}
          history={this.props.history}
        />
      </>
    );
  }
}

export default Arpage;
